module.exports = __webpack_public_path__ + "static/Rat-841e7bc281a7b9dfde04bf87b1b02b6f.jpg";